define.alias("shared/components/shared/post/secondary/activity/body", "calendar/components/shared/post/secondary/activity/body");